(function () {
  const ADD_TO_CART_TEXT = 'Add to Cart';
  const SCHEDULE_TEXT = 'Schedule Your Time';
  // Our own transient button states — enforceButtonState must NOT overwrite these.
  const OUR_STATES = ['adding', 'added', 'view cart', 'processing'];

  function getCheckbox() { return document.getElementById('fitting-checkbox'); }
  function getAppointoBtn() { return document.getElementById('appointo-btn'); }
  function isFittingChecked() { const cb = getCheckbox(); return cb ? cb.checked : false; }

  // HEALTH SIGNAL: Appointo injects #appointo-btn only when its backend config
  // loads successfully. If its API errors (500), the button never appears. So
  // #appointo-btn present === Appointo is working for this product, right now.
  function appointoHealthy() { return !!getAppointoBtn(); }

  function openCartDrawerAfterAdd() {
    if (window.Shopify && window.Shopify.designMode) return;
    var el = document.getElementById('offcanvas-cart');
    if (!el || !window.bootstrap) return;
    if (typeof window.refreshCartContents === 'function') {
      try { window.refreshCartContents({ ok: true, url: '/cart/add.js', json: function () { return Promise.resolve({}); } }); } catch (e) { /* no-op */ }
    }
    window.bootstrap.Offcanvas.getOrCreateInstance(el).show();
  }

  // ── Cart/drawer upsell cards (always plain add — never scheduled) ───────────
  window.caUpsellToggleFitting = function (cb) {
    var wrap = cb.closest('.ca-upsell-form');
    if (!wrap) return;
    var card = cb.closest('.product-item') || wrap;
    var priceEl = card.querySelector('.product-item-price-final');
    if (priceEl) priceEl.textContent = cb.checked ? wrap.dataset.yesPrice : wrap.dataset.noPrice;
    var cmp = card.querySelector('.product-item-price-compare');
    if (cmp) cmp.style.display = cb.checked ? 'none' : '';
  };
  window.caUpsellAdd = function (btn) {
    if (window.Shopify && window.Shopify.designMode) return;
    var wrap = btn.closest('.ca-upsell-form');
    var id = btn.dataset.variantId;
    if (wrap && wrap.dataset.noId) { var cb = wrap.querySelector('.ca-upsell-fitting'); id = (cb && cb.checked) ? wrap.dataset.yesId : wrap.dataset.noId; }
    if (!id) return;
    btn.disabled = true; var original = btn.textContent; btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = original; btn.disabled = false;
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (typeof window.refreshCartContents === 'function') { try { window.refreshCartContents({ ok: true, url: '/cart/add.js', json: function () { return Promise.resolve({}); } }); } catch (e) { } }
        var el = document.getElementById('offcanvas-cart');
        if (el && window.bootstrap && !document.getElementById('cart')) { window.bootstrap.Offcanvas.getOrCreateInstance(el).show(); }
      })
      .catch(function () { btn.textContent = original; btn.disabled = false; });
  };

  // ── Main fitting-product button ─────────────────────────────────────────────
  function currentAtcBtn() {
    return getAppointoBtn() || document.querySelector('form.shopify-product-form .btn-atc, form.shopify-product-form button[name="add"]');
  }
  function selectedVariantId() {
    var form = document.querySelector('form.shopify-product-form');
    var idField = form && form.querySelector('[name="id"]');
    var cb = getCheckbox();
    if (form && cb) {
      var variants = [];
      try { variants = JSON.parse(form.dataset.variants || '[]'); } catch (e) { variants = []; }
      if (variants.length) {
        var yesVal = cb.getAttribute('data-yes-value') || 'Yes - Product & Fitting';
        var yesV = variants.filter(function (v) { return v.option1 === yesVal || /yes/i.test(v.option1 || ''); })[0];
        var noV = variants.filter(function (v) { return v !== yesV; })[0];
        var chosen = cb.checked ? yesV : noV;
        if (chosen) return String(chosen.id);
      }
    }
    return idField ? idField.value : null;
  }

  // Label rule: "Schedule Your Time" ONLY when fitting is ticked AND Appointo is
  // healthy (so the calendar can actually open). Otherwise "Add to Cart".
  // This never shows Appointo's "Loading Calendar..."/dim state.
  function enforceButtonState() {
    if (window.Shopify && window.Shopify.designMode) return;
    var btn = currentAtcBtn();
    if (!btn) return;
    var t = (btn.textContent || '').toLowerCase().trim();
    if (OUR_STATES.some(function (s) { return t.indexOf(s) !== -1; })) return;
    var label = (isFittingChecked() && appointoHealthy()) ? SCHEDULE_TEXT : ADD_TO_CART_TEXT;
    if (btn.textContent.trim() !== label) btn.textContent = label;
    if (parseFloat(btn.style.opacity || '1') < 1) btn.style.opacity = '';
    if (btn.disabled) btn.disabled = false;
  }
  var scheduled = false;
  function scheduleEnforce() { if (scheduled) return; scheduled = true; (window.requestAnimationFrame || window.setTimeout)(function () { scheduled = false; enforceButtonState(); }, 0); }

  function addSelectedToCart(btn) {
    if (window.Shopify && window.Shopify.designMode) return;
    var id = selectedVariantId();
    if (!id) return;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓ Added to Cart';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () { enforceButtonState(); }, 2500);
        openCartDrawerAfterAdd();
      })
      .catch(function () { enforceButtonState(); });
  }

  // Click routing on fitting products:
  //  - ticked + Appointo healthy → let Appointo open its calendar (don't intercept)
  //  - everything else (unticked, OR ticked while Appointo is down) → add directly
  document.addEventListener('click', function (e) {
    if (!getCheckbox()) return; // non-fitting product → theme handles it normally
    var btn = e.target.closest && e.target.closest('#appointo-btn, form.shopify-product-form .btn-atc, form.shopify-product-form button[name="add"]');
    if (!btn || btn.classList.contains('ca-upsell-add')) return;
    if (isFittingChecked() && appointoHealthy()) return; // hand off to Appointo's scheduling widget
    e.stopImmediatePropagation();
    e.preventDefault();
    addSelectedToCart(btn);
  }, true);

  document.addEventListener('change', function (e) { if (e.target && e.target.id === 'fitting-checkbox') enforceButtonState(); });
  document.addEventListener('variant:changed', function () { enforceButtonState(); });

  // Control the label from first paint and keep it correct as Appointo loads
  // (or fails). The MutationObserver re-runs whenever Appointo injects/changes the
  // button, so the "Schedule Your Time" ↔ "Add to Cart" switch is fully automatic.
  function start() {
    enforceButtonState();
    [100, 400, 900, 1800, 3000, 5000].forEach(function (ms) { setTimeout(enforceButtonState, ms); });
    var obs = new MutationObserver(scheduleEnforce);
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'disabled', 'id'], characterData: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
